export default __webpack_public_path__ + "static/media/klaus-kroschke-gruppe.83dbb5bf.webp";